module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcUlEQVQ4y2NgGBTgP5kAYYLFjv9kYaoZgMuJ+8++/b/3zBvCXkCX+P3n3/+GOXf+xzVcAuP62bfBYkQbAAI5Pdf+Hzz/7v/hi+//Z3VfI90FIFvjgbbHN176XzeLDBeAwN4zb//vOf1mKEcj8SlxSAMAE/jj6SMqRp4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IL.png
// module id = 1167
// module chunks = 0